module.exports = __webpack_public_path__ + "img/video-poster.b822c993.png";